import api from "./api";
import StorageService from "./StorageService";

const BranchService = {
  getAllBranches: async (page = 1, limit = 10, filters = {}) => {
    try {
      const { branchName, status } = filters;
      let url = `/branches?page=${page}&limit=${limit}`;
      if (branchName) url += `&branchName=${branchName}`;
      if (status !== undefined && status !== '') url += `&status=${status}`;

      const res = await api.get(url);
      return res.data;
    } catch (error) {
      if (error.response && error.response.data) {
        throw new Error(error.response.data.message || "Failed to fetch branches");
      } else {
        throw new Error("Unable to connect to server");
      }
    }
  },

  getBranchById: async (id) => {
    try {
      const res = await api.get(`/branches/${id}`);
      return res.data;
    } catch (error) {
      if (error.response && error.response.data) {
        throw new Error(error.response.data.message || "Failed to fetch branch");
      } else {
        throw new Error("Unable to connect to server");
      }
    }
  },

  createBranch: async (data) => {
    try {
      const payload = { ...data, createdBy: StorageService.loginData().employeeId };
      const res = await api.post("/branches", payload);
      return res.data;
    } catch (error) {
      if (error.response && error.response.data) {
        throw new Error(error.response.data.message || "Failed to create branch");
      } else {
        throw new Error("Unable to connect to server");
      }
    }
  },

  updateBranch: async (id, data) => {
    try {
      const payload = { ...data, updatedBy: StorageService.loginData().employeeId };
      const res = await api.put(`/branches/${id}`, payload);
      return res.data;
    } catch (error) {
      if (error.response && error.response.data) {
        throw new Error(error.response.data.message || "Failed to update branch");
      } else {
        throw new Error("Unable to connect to server");
      }
    }
  },

  updateStatus: async (id, status) => {
    try {
      const res = await api.patch(`/branches/${id}/status`, { status, updatedBy: StorageService.loginData().employeeId });
      return res.data;
    } catch (error) {
      if (error.response && error.response.data) {
        throw new Error(error.response.data.message || "Failed to update branch status");
      } else {
        throw new Error("Unable to connect to server");
      }
    }
  }
};

export default BranchService;
